
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import Chart from 'chart.js'
import { Line, mixins } from 'vue-chartjs'
/* module */
import DateClass from '@/app/module/date'

@Component({})
export default class Graph extends Mixins(Line, mixins.reactiveProp) {
  @Prop() public chartData: any
  @Prop() public chartOptions: any

  public legend: any = {}

  mounted () {
    this.renderChart(this.chartData, this.chartOptions)
    let legend: string = this.$data._chart.generateLegend()

    // メインチャートの凡例
    if (legend.charAt(0) === '0') {
      let chart: any = document.getElementById('legend-1')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    } else if (legend.charAt(0) === '1') {
      let chart: any = document.getElementById('legend-2')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    } else if (legend.charAt(0) === '2') {
      let chart: any = document.getElementById('legend-3')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    } else if (legend.charAt(0) === '3') {
      let chart: any = document.getElementById('legend-4')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    } else if (legend.charAt(0) === '4') {
      let chart: any = document.getElementById('legend-5')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    } else if (legend.charAt(0) === '5') {
      let chart: any = document.getElementById('legend-6')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    } else if (legend.charAt(0) === '6') {
      let chart: any = document.getElementById('legend-7')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    } else if (legend.charAt(0) === '7') {
      let chart: any = document.getElementById('legend-8')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    }

    this.$emit('create-slideber')
    this.$emit('display-legend')
    this.$emit('display-area-legend')
  }

  /* details側で日付変更された際は取得して再renderする */
  public updateGraph (options: any) {
    this.$data._chart.clear()
    if (options !== null && options !== undefined) {
      this.chartOptions = options
    }
    this.renderChart(this.chartData, this.chartOptions)
  }

  /* chartjsの関数を定義 */
  public renderChart!: (chartData: any, options: any) => void
}
